module.exports = __webpack_public_path__ + "static/media/workload.b4d7a3b3.png";